class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: '.header'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
        this.headerScroll();
        this.initEventListeners();

        setTimeout(() => {
            this.$scope.removeClass('no-transition');
        }, 400);
	}

    initEventListeners() {
        $(window).on("scroll", () => this.headerScroll());
    }

    headerScroll() {
        let top = window.scrollY;
        if (top > 100) {
            this.headerAddScroll();
        } else {
            this.headerRemoveScroll();
        }
    }

    headerAddScroll() {
        this.$scope.addClass('header-scroll');
    }

    headerRemoveScroll() {
        this.$scope.removeClass('header-scroll');
    }
}

export default new Header;
